import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewEncapsulation,
} from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { MatSelectChange } from "@angular/material/select";
import i18next from "i18next";
import { translateAndFormat } from "src/app/i18next";

const customPaginatorIntl = new MatPaginatorIntl();

// This event modifies the labels and text displayed in the paginator
// see also: https://github.com/angular/components/blob/master/src/material/paginator/paginator-intl.ts
// see also: https://github.com/angular/components/issues/5573
i18next.on("initialized", () =>
	Object.assign(customPaginatorIntl, {
		itemsPerPageLabel: `${translateAndFormat("rows per page", "capitalize")}:`,
		previousPageLabel: translateAndFormat("previous page", "capitalize"),
		nextPageLabel: translateAndFormat("next page", "capitalize"),
	}),
);

@Component({
	selector: "app-paginator",
	templateUrl: "./paginator.component.html",
	styleUrls: ["./paginator.component.scss"],
	providers: [{ provide: MatPaginatorIntl, useValue: customPaginatorIntl }],
	encapsulation: ViewEncapsulation.ShadowDom,
})
export class PaginatorComponent implements OnInit, OnChanges {
	@Input() length: number;
	@Input() page = "1";
	@Input() pageSizeOptions: ReadonlyArray<number>;
	@Output() pageQueryChange: EventEmitter<URLSearchParams> = new EventEmitter();

	pageIndex = 0;
	pageSize = 0;
	id = Math.random().toString(36).substring(7);

	/** The previous page index */
	private previousPageIndex: number;
	ngOnChanges(changes: SimpleChanges): void {
		const pageChange = changes?.["page"];
		if (pageChange && pageChange.currentValue != null) {
			const n = Number(pageChange.currentValue);
			// valid, 1-based page incoming -> 0-based index internally
			this.pageIndex = Number.isFinite(n) && n > 0 ? n - 1 : 0;
		}
	}
	ngOnInit() {
		this.pageSize = this.pageSizeOptions[0];

		this.previousPageIndex = this.pageIndex;
	}

	resetPageIndex() {
		this.pageIndex = 0;
		this.previousPageIndex = 0;
	}

	/** [startOnPage]-[lastOnPage] of [length] */
	public get startOnPage() {
		return this.pageIndex * this.pageSize + 1;
	}

	/** [startOnPage]-[lastOnPage] of [length] */
	public get lastOnPage() {
		const lastOnPage = (this.pageIndex + 1) * this.pageSize;

		return lastOnPage > this.length ? this.length : lastOnPage;
	}

	public get isLastPage() {
		return this.lastOnPage >= this.length;
	}

	onPageIndexChange(change: number) {
		this.previousPageIndex = this.pageIndex;
		this.pageIndex = this.pageIndex + change;
		this.emitPageEvent();
	}

	onSelectionChange({ value }: MatSelectChange) {
		this.pageSize = value;
		this.resetPageIndex();
		this.emitPageEvent();
	}

	emitPageEvent() {
		this.pageQueryChange.emit(
			new URLSearchParams({
				page: `${this.previousPageIndex <= this.pageIndex ? this.pageIndex + 1 : this.previousPageIndex}`,
				perPage: `${this.pageSize}`,
			}),
		);
	}
}
